import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceMid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVoiceMid"><Path d="M7.5 5.5V18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 10.5V13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 9.5V14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 7.5V16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 10.5V13.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVoiceMid;
